import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Box, Grid } from '@mui/material';
import { X } from 'lucide-react';
import LangEnum from '../../lang/LangEnum';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { useTranslation } from '../translation/TranslationContext';
import OrderActiveTitle from './OrderActiveTitle';
import useOrderBook from './hooks/useOrderBook';

const OrderBookHeader = () => {
  const { closeOrderBook } = useOrderBook();
  const { translate } = useTranslation();

  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Grid>
        <OrderActiveTitle />
      </Grid>
      <Grid>
        <Box
          sx={{
            display: 'flex',
            columnGap: 2,
          }}
        >
          <IconButton
            icon={X}
            size="medium"
            testId={ActiveOrderTestIds.CLOSE_BUTTON}
            ariaLabel={translate(LangEnum.GLOBAL_CLOSE)}
            onClick={closeOrderBook}
            sx={(theme) => ({
              color: theme.palette.accent.light,
            })}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrderBookHeader;
